import React, { useEffect, useState } from 'react';
import { Box, Grid2 } from '@mui/material';
import {
  useGetOpsStaffDetailsById,
  useGetOpsStaffMetaData,
} from '../../API/hooks/opsStaffHook';
import { useNavigate, useParams } from 'react-router';
import opsStaffInitialValues from './opsStaffInitialValues';

import BackIcon from '@assets/images/BackIcon.svg';
import {
  CustomDivider,
  CustomIconButton,
  CustomTypography,
} from '@qler-view/shared_lib/src';
import {
  NEW_OPSSTAFF_ROUTE_PATH,
  OPSSTAFF_ROUTE_PATH,
} from '../../routers/routePaths';
import CustomButton from '@qler-view/shared_lib/src/shared/lib/ui-components/Button/CustomButton';
import { hasRole } from '../login/storageUtility';
const ViewOpsStaff: React.FC = () => {
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId') ?? '0';
  const { opsStaffId } = useParams<{ opsStaffId?: string }>();
  const { OpsStaffMetaData } = useGetOpsStaffMetaData(userId);
  const { OpsStaffDetailsById, isLoading } = useGetOpsStaffDetailsById(
    userId,
    Number(opsStaffId)
  );

  const [initialOpsStaffValues, setInitialOpsStaffValues] = useState(
    opsStaffInitialValues
  );
  useEffect(() => {
    if (OpsStaffDetailsById) {
      setInitialOpsStaffValues(OpsStaffDetailsById);
    }
  }, [OpsStaffDetailsById]);

  const handleEditFacilityInfo = (facilityId: number) => {
    navigate(NEW_OPSSTAFF_ROUTE_PATH + `/${facilityId}`);
  };

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <CustomTypography
          id="loading-text"
          variant="h5"
          className="text-align-center pt-32"
          color="textDisabled"
        >
          Loading...
        </CustomTypography>
      </Box>
    );
  }
  return (
    <Box>
      <Box className="pt-20 pb-20">
        <Grid2 container>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Box className=" flex-justify-space-between align-items-baseline">
              <Box className="text-align-left display-flex">
                <CustomIconButton
                  id="back-button-ops-staff"
                  icon={<BackIcon />}
                  onClick={() => {
                    navigate(OPSSTAFF_ROUTE_PATH, { replace: true });
                  }}
                ></CustomIconButton>
                <CustomTypography
                  className="pl-8"
                  variant="h4"
                  id="add-new-ops-staff-title"
                >
                  View Ops Staff
                </CustomTypography>
              </Box>
              {hasRole(['ops-admin']) && (
                <Box>
                  <CustomButton
                    id="save-button"
                    onClick={() => {
                      handleEditFacilityInfo(initialOpsStaffValues.id);
                    }}
                    variant="contained"
                  >
                    Edit
                  </CustomButton>
                </Box>
              )}
            </Box>
          </Grid2>
        </Grid2>
      </Box>
      <Box className="form-background p-24">
        <Grid2 container>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <CustomTypography
              variant="h5"
              className="text-align-left pb-32"
              id="ops-staff-info-title"
            >
              Ops Staff Information
            </CustomTypography>
          </Grid2>
        </Grid2>
        <Box className="display-flex">
          <Grid2 container spacing={4} className="width-80">
            <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
              <CustomTypography
                id="ops-staff-first-name-label"
                variant="body3"
                color="textDisabled"
                className="text-align-left pb-12"
              >
                First Name
              </CustomTypography>
              <CustomTypography
                id="ops-staff-first-name-value"
                variant="body3"
                color="textPrimary"
                className="text-align-left"
              >
                {initialOpsStaffValues.firstName ?? ''}
              </CustomTypography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
              <CustomTypography
                id="ops-staff-last-name-label"
                variant="body3"
                color="textDisabled"
                className="text-align-left pb-12"
              >
                Last Name
              </CustomTypography>

              <CustomTypography
                id="ops-staff-last-name-value"
                variant="body3"
                color="textPrimary"
                className="text-align-left"
              >
                {initialOpsStaffValues.lastName ?? ''}
              </CustomTypography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
              <CustomTypography
                id="ops-staff-primary-email-label"
                variant="body3"
                color="textDisabled"
                className="text-align-left pb-12"
              >
                Primary Email
              </CustomTypography>

              <CustomTypography
                id="ops-staff-primary-email-value"
                variant="body3"
                color="textPrimary"
                className="text-align-left pb-12"
              >
                {initialOpsStaffValues.primaryEmail ?? ''}
              </CustomTypography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
              <CustomTypography
                id="ops-staff-role-label"
                variant="body3"
                color="textDisabled"
                className="text-align-left pb-12"
              >
                Role
              </CustomTypography>

              <CustomTypography
                id="ops-staff-role-value"
                variant="body3"
                color="textPrimary"
                className="text-align-left"
              >
                {
                  OpsStaffMetaData?.roles.find(
                    (role) => role.id === initialOpsStaffValues.roleId
                  )?.name
                }
              </CustomTypography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
              <CustomTypography
                id="ops-staff-user-status-label"
                variant="body3"
                color="textDisabled"
                className="text-align-left pb-12"
              >
                Status
              </CustomTypography>
              <CustomTypography
                id="ops-staff-user-status-value"
                variant="body3"
                color="textPrimary"
                className="text-align-left"
              >
                {initialOpsStaffValues.status ? (
                  <Box className="display-flex align-items-baseline">
                    <Box component="span" className="status-active-dot " />
                    <CustomTypography
                      id="live-on-qler-value"
                      variant="body3"
                      color="textPrimary"
                      className="text-align-left pl-4"
                    >
                      {' '}
                      Active
                    </CustomTypography>
                  </Box>
                ) : (
                  <Box className="display-flex align-items-baseline">
                    <Box component="span" className="status-inactive-dot " />
                    <CustomTypography
                      id="live-on-qler-value"
                      variant="body3"
                      color="textPrimary"
                      className="text-align-left pl-4"
                    >
                      {' '}
                      Inactive
                    </CustomTypography>
                  </Box>
                )}
              </CustomTypography>
            </Grid2>
          </Grid2>
        </Box>
        <Box className="pt-32">
          <CustomDivider />
        </Box>
        <Box className="pt-32">
          <Grid2 container spacing={4} className="width-80">
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <CustomTypography
                variant="h5"
                className="text-align-left pb-32"
                id="staff-notes-label"
              >
                Ops Staff Notes
              </CustomTypography>
            </Grid2>
          </Grid2>
          <Grid2 container spacing={4} className="width-80">
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <CustomTypography
                id="notes-label"
                variant="body3"
                color="textDisabled"
                className="text-align-left pb-12"
              >
                Notes
              </CustomTypography>
              <CustomTypography
                id="notes-value"
                variant="body3"
                color="textPrimary"
                className="text-align-left pb-12"
              >
                {initialOpsStaffValues.notes ?? ''}
              </CustomTypography>
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </Box>
  );
};

export default ViewOpsStaff;
